import { BottomSheet } from './BottomSheet';
import { Button } from './Button';
import styles from './NoticeSheet.module.css';
import { sheetStyles } from './sheetStyles';

export interface NoticeSheetProps {
  /** The message itself, in the sheet's head: it is the dialog's name, so it is what is read out first. */
  title: string;
  /** What to do about it, when there is something to do. */
  message?: string;
  /** The one button. */
  okLabel: string;
  /** OK, a swipe, the backdrop and Escape all end here: there is nothing to decide. */
  onClose: () => void;
}

/**
 * A message with one button. The request of 5 October 2026 (third), section 1:
 * "a clear message with a single OK button, not an error".
 *
 * For something a person has to read before carrying on, where there is nothing
 * to choose: a toast would be gone before it was read, and the confirmation
 * asks a question this does not ask. It carries no tone, mark or colour of an
 * error, because it is not one. The head has no close button, so OK is the only
 * control and takes the focus; a swipe, the backdrop and Escape close it too,
 * and all of them mean OK.
 */
export function NoticeSheet({ title, message, okLabel, onClose }: NoticeSheetProps) {
  return (
    <BottomSheet
      title={title}
      onClose={onClose}
      // Not drawn: the head has no close button. Closing it any other way is the same OK.
      closeLabel={okLabel}
      hideClose
      footer={
        <div className={sheetStyles.actions}>
          <Button variant="primary" className={sheetStyles.primary} onClick={onClose} data-autofocus>
            {okLabel}
          </Button>
        </div>
      }
    >
      {message !== undefined && <p className={styles.message}>{message}</p>}
    </BottomSheet>
  );
}
